/**
 * Registers the `table_create` command in the entityCreationRegistry so the
 * sidebar "+" menu offers "Table" as a creatable entity type.
 *
 * The actual tool-runtime call lives in ../tableCommands.ts. This file exists
 * only to run the registration side-effect at import time.
 */

import { entityCreationRegistry } from '../../../../services/entityCreationRegistry';

entityCreationRegistry.register({
  commandId: 'table_create',
  entityType: 'Table',
  displayName: 'Table',
  icon: {
    type: 'phosphor',
    phosphorIcon: 'Table',
    phosphorWeight: 'duotone',
  },
  description: 'Create a database-style table with columns and rows',
  canCreateInFolder: true,
  openAfterCreate: true,
  category: 'data',
  sortOrder: 5,
});
